
import { Component, Vue } from 'vue-property-decorator'
import ButtonBase from '@/components/atoms/ButtonBase.vue'

/**
 * 送信、遷移系の四角ボタン
 */
@Component({
  components: {
    ButtonBase,
  },
})
export default class ButtonSubmitSquare extends Vue {
  /**
   * クリックイベントの発火を親コンポーネントに通知する
   *
   * @param event イベントオブジェクト
   */
  private clickEvent(event: Event): void {
    this.$emit('click', event)
  }
}
